import { useEffect, useState } from 'react';
import { PaymentFailPage } from './payment/PaymentFailPage';
import { DesktopPaymentFailPage } from './desktop/DesktopPaymentFailPage';

export function ResponsivePaymentFailPage() {
  const [isMobile, setIsMobile] = useState(true);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth < 1024);
    };

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);

    return () => {
      window.removeEventListener('resize', checkScreenSize);
    };
  }, []);

  return isMobile ? <PaymentFailPage /> : <DesktopPaymentFailPage />;
}